import type {
  EstimateGasFn,
  GetTransactionReceiptFn,
  SendTransactionFn,
} from "../wallet-portfolio/types";
import type { OnOutlink } from "../../lib/outlink";
import type { Environment, Theme } from "../../types";

export const NATIVE_TOKEN_SENTINEL_ADDRESS =
  "0x0000000000000000000000000000000000000001";

export interface SendAsset {
  name: string;
  symbol: string;
  chainId: number;
  address: string;
  quantity: {
    decimals: number;
    numeric: string;
  };
  icon_url: string;
}

export type SendStatus =
  | "idle"
  | "review"
  | "submitting"
  | "confirming"
  | "success"
  | "error";

export interface RecentSendAddress {
  address: `0x${string}`;
  updatedAt: number;
}

export interface SendAccount {
  address: `0x${string}`;
  index?: number;
  name?: string;
}

export interface SendPageProps {
  env?: Environment;
  theme?: Theme;
  walletAddress: string;
  accountName?: string;
  accounts?: SendAccount[];
  token: SendAsset;
  tokens?: SendAsset[];
  onTokenChange?: (token: SendAsset) => void;
  sendTransaction?: SendTransactionFn;
  getTransactionReceipt?: GetTransactionReceiptFn;
  /**
   * 확인 단계에서 표시할 가스/수수료 추정 함수. 주입되지 않으면 Gas/Est.Time/Max.Gas 행은 "—"로 표시된다.
   * 사용자가 Send 버튼을 눌러 확인 화면에 진입할 때 한 번 호출된다.
   */
  estimateGas?: EstimateGasFn;
  onSuccess?: (txHash: `0x${string}`) => void;
  onConfirmSuccess?: (txHash?: `0x${string}`) => void;
  onOutlink?: OnOutlink;
}
